<!-- 
  algolia 版本搜索

 -->
<template>
  <div class="page">
    <!-- 头部 -->
    <YorkbbsHeader :width="'1170px'"></YorkbbsHeader>

    <!-- 搜索/导航 -->
    <YorkbbsSearchNav :topicVisible="false"></YorkbbsSearchNav>

    <!-- <div class="main-wrapper" v-if="initialUiState.info_main.query.length == 0">
      <div class="lr-infos" >
          <div class="no-result">
            <img :src="require('@/assets/images/common/no-search-result.png')" alt="" width="216">
            <p class="note">暂无可显示内容</p>
            <p>很抱歉，没有可显示内容</p>
            <p>可以尝试提供关键字进行搜索</p>
          </div>
        </div>
    </div> -->

    <div class="main-wrapper" >
      <ais-instant-search
        ref="instantSearch"
        index-name="info_main"
        :insights="insights"
        :search-client="client"
        :initial-ui-state="initialUiState"
        :future="{preserveSharedStateOnUnmount:true}"
      >
        <ais-search-box>
          <template v-slot="{ currentRefinement, isSearchStalled, refine }">
            <div style="display:none">
              <input
                type="search"
                :value="currentRefinement"
                @input="refine($event.currentTarget.value)"
              >
              <span :hidden="!isSearchStalled">Loading...</span>
            </div>

            
          </template>
        </ais-search-box>
        <div v-if="queryTooMany">
          <div class="no-result" >
            <img :src="require('@/assets/images/common/no-data.png')" alt="" width="216">
            <p class="note">搜索失败</p>
            <p>很抱歉，检测到您操作频率过高，无法搜索</p>
            <p>请间隔一段时间后再次使用</p>
          </div>
        </div>
        <div class="warp-cont" v-else>

          <div class="lf-category">
            <ais-panel>
              <div class="view-filter">
                <div class="title-text">浏览和筛选</div>
                <div class="control">
                  <ais-clear-refinements :included-attributes="['categories_lvl0','categories_lvl1']" >
                    <template v-slot="{ canRefine, refine, createURL }">
                      <a
                        class="clear-filter-control"
                        :href="createURL()"
                        @click.prevent="refine"
                        v-if="canRefine"
                      >
                        清空 <i class="el-icon-close"></i>
                      </a>
                      <div v-else></div>
                    </template>
                  </ais-clear-refinements>
                </div>
              </div>
              
              
            
              <div class="category-title">类别</div>
              <ais-hierarchical-menu :attributes="['categories_lvl0','categories_lvl1']" :sort-by="['count:desc']">
                <template
                    v-slot="{
                      items,
                      refine
                    }"
                  >
                
                    <ul class="category-tree" v-for="(item,index) in items " :key="item.label+'_'+index">
                      <li @click="refine(item.label)" :class="{active:item.isRefined}">
                        <div class="flex-cont">{{item.label}}</div>
                        <div class="count">{{item.count}}</div>
                      </li>
                      <template v-if="item.data&& item.data.length>0">
                        <li class="next-level" :class="{active:dataItem.isRefined}" @click="refine(dataItem.value)" v-for="(dataItem,dataIndex) in item.data" :key="dataItem.label+'_'+dataIndex">
                          <div class="flex-cont">{{dataItem.label}}</div>
                          <div class="count">{{dataItem.count}}</div>
                        </li>
                      </template>
                    </ul>
                    <!-- {{items}} -->
                  </template>
              </ais-hierarchical-menu>
            </ais-panel>
          </div>

          <div class="lr-infos">
            <!-- //AisStateResults -->
            <ais-state-results>
              <template v-slot="{ status }">
                <ais-infinite-hits :escapeHTML="false" :canRefine="true"  :limit="50" :cache="cache">
                  <template v-slot="{ items,refineNext,isLastPage,sendEvent }">
                    
                    <AlgoliaResultItem v-for="item in items" :key="item.objectID" :info="item" @clickResult="(eventName )=>sendEvent('conversion',item,eventName)"/>

                    <div v-if="status === 'loading' || status == 'stalled' " class="loading"><i class="el-icon-loading"></i> 加载中</div>
                    <div v-if="!isLastPage && status !== 'loading' && status !== 'stalled' && items.length>0" class="load-more">
                      <button @click="refineNext">
                        点击加载更多
                      </button>
                    </div>
                    
                    <div class="no-result" v-if="status !== 'loading' && status !== 'stalled' && items.length == 0 && post.list.length == 0">                    
                        <YorkbbsEmptyResult                         
                          text="没有搜索到你要找的信息"
                        ></YorkbbsEmptyResult>                     
                    </div>
                    <div v-else-if="items.length < 6 && post.list.length > 0">                      
                     
                      <ItemAll v-for="(item) in post.list" :key="item.id" :info="item" :keyword="keyword"/>
                      
                    </div>
                    <div v-if="isLastPage && items.length>0" class="no-more">没有更多了</div>
                  </template>
                </ais-infinite-hits>
              </template>
            </ais-state-results>
            
          </div>
          </div>
        
      </ais-instant-search>
    </div>
    <div>
     
    
      </div>
  </div>
</template>
<script>
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsSearchNav from '../components/search-nav.vue';
import YorkbbsEmptyResult from '@/common/empty-result/empty-result.vue';
import algoliasearch from 'algoliasearch'; 
import AlgoliaResultItem from './algolia-result-item.vue'
import {
  createInfiniteHitsSessionStorageCache
} from 'instantsearch.js/es/lib/infiniteHitsCache'
import { AisInstantSearch,AisInfiniteHits,AisHits,AisPanel,AisRefinementList,AisMenu,AisMenuSelect,AisHierarchicalMenu,AisSearchBox,AisClearRefinements,AisHighlight,AisStateResults } from 'vue-instantsearch';
import ItemAll from './item-all.vue'

export default {
  name: 'Search',
  components: {
    YorkbbsHeader,
    YorkbbsSearchNav,
    AlgoliaResultItem,
    AisInstantSearch,
    AisInfiniteHits,
    AisHits,
    AisPanel,
    AisRefinementList,
    AisMenu,
    AisMenuSelect,
    AisHierarchicalMenu,
    AisSearchBox,
    AisClearRefinements,
    AisHighlight,
    AisStateResults,
    ItemAll,
    YorkbbsEmptyResult,
  },
  
  computed:{
    user(){
      return this.$store.getters.user||{}
    }
  },
  
  data() {
    return {
      client:{},
      initialUiState:{
        "info_main":{query:''}
      },
      cache:createInfiniteHitsSessionStorageCache(),
      insights:{
        insightsInitParams: {
          useCookie: true,
        },
      },
      queryTooMany:false,
      dataLoading:false,
      

      //全站搜索结果
      keyword: '',
      sortType:0,
      post: {
        loading: false,
        offset: 1,
        size: 30,
        itemTotal: 0,
        list: [],
      },
    };
  },
  mounted(){
    this.checkoutUser();
  },
  beforeCreate(){
    
  },
  created() {
       
    const { keyword } = this.$route.query;
    
    if( keyword.length >0 ){
      this.initialUiState.info_main.query = keyword;
    }
     
    this.client = this.getSearchClient();
    
    //全站搜索
    if( this.$route.query.keyword){     
      this.keyword = this.$route.query.keyword;
      this.getPostList();
    }

   
    
  },
  methods: {
    getSearchClient(){
     
      var self = this;
      var algoliaClient = algoliasearch('UT21IPU9SI','62a06fe02fb9d94621e49535d11a7ba4',{
        future: {
          preserveSharedStateOnUnmount: true,
        },
      })
    
      return  {
        ...algoliaClient,
        search(requests) {
        
          try{
            if (requests.every(({ params }) => !params.query)) {
              return Promise.resolve({
                results: requests.map(() => ({
                  hits: [],
                  nbHits: 0,
                  nbPages: 0,
                  page: 0,
                  processingTimeMS: 0,
                  hitsPerPage: 0,
                  exhaustiveNbHits: false,
                  query: '',
                  params: '',
                })),
              });
            }
            
            requests[0].params['hitsPerPage'] = 50;
            
            return algoliaClient.search(requests).then(res=>{
              
              self.queryTooMany = false;
              return res;
            }).catch(err=>{
              
              if( err.status == 429 ){
                
                self.queryTooMany = true; 
              }
            });
          }catch(err){
            alert('出错了')
          }
        },
      };
    },
   
    checkoutUser(){
      if( this.user.id ){
        window.aa('setUserToken', this.user.id);
      }else{
        setTimeout(()=>{
          this.checkoutUser();
        },1000)
      }
    },
    toggleShowMore(){},
    loadMoreBefore(refineNext){
      this.dataLoading=true;
      refineNext()
    },
    transformItems(items){
      this.dataLoading = false;
      
      return items;
    },

    // 全站搜索
    async getPostList() {
      var url = '/searchs/v1/all/posts';
      const app = 'all_post';

      this.post.loading = true;
      var sendData = {
        app: app,
        offset: this.post.offset,
        size: this.post.size,
        keyword: this.$route.query.keyword,
        sortType: 0,
        createdAfter: '',
      }
   
      const { data } = await this.$axios
        .post(url,sendData )
        .finally(() => {
          this.post.loading = false;
        });

      this.post.list = data.items;
      this.post.itemTotal = data.itemTotal;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  width: 1170px;
  margin: auto;
  
}
.main-wrapper {
  width: 1170px;
  margin: 50px auto 0;
  display: flex;
  justify-content: space-between;
  ::v-deep{
    .ais-InstantSearch{width:100%;}
  }
}
.warp-cont{
  display:flex; width: 100%;
  .lf-category{
    width:300px; margin-right: 40px;
  }
  .lr-infos{
    flex:1; overflow: hidden;
  }
  .view-filter{
    display: flex; align-items: center; padding-bottom: 20px; border-bottom: 1px solid #dedede; margin-bottom: 20px;
    .title-text{
      flex:1; font-size: 16px; font-weight: bold;
    }
    .control{font-size: 12px; color: #666;} 
  }
  .category-title{font-size: 16px; margin-bottom: 20px; font-weight: bold;}
  .category-tree{
    li{
      display: flex; align-items: center; height: 36px; user-select: none; cursor: pointer;
      .count{background: #f5f5fa; border: 1px solid #d6d6e7; line-height: 14px; font-size: 12px; color: #5a5e9a; padding: 0 8px; border-radius: 9px;}
      .flex-cont{flex:1;}
      &.active{
        .flex-cont{color: #e43a3a;}
      }
      &.next-level{padding-left: 30px;
        .flex-cont{font-size: 16px;}
      }
      &:hover{
        .flex-cont{color: #e43a3a; opacity: 0.8;}
      }
    }
  }
  .load-more{
    display: flex; justify-content: center; height: 30px; align-items: center; 
    margin-bottom: 20px;
  }
  .no-more{
    font-size: 12px; color: #999; text-align: center; margin-bottom: 20px;display: flex; height: 30px; align-items: center; justify-content: center;
  }
  .loading{
    font-size: 12px; color: #999; display: flex; height: 30px; align-items: center; justify-content: center; margin-bottom: 20px;
    i{margin-right: 5px;}
  }
}

.no-result{
  display: flex; flex-direction: column; justify-content: center; align-items: center; user-select: none;
  p{
    color: #A8A9AF; font-size: 14px; line-height: 26px;
    &.note{font-size: 16px; color: #666; margin:10px 0}
  }
}
</style>
